import React from "react";

const KycDetails = ({ customerById }) => {
  const { aadhar_number, pan_number } = customerById;
  return (
    <>
      <div className='pt-3'>
        <div className='settings-form'>
          <h4 className='text-primary'>KYC Details</h4>
          <div className='row'>
            <div className='form-group mb-3 col-md-6'>
              <label className='form-label'>Aadhaar Number</label>
              <input disabled type='password' className='form-control' value={aadhar_number} />
            </div>
            <div className='form-group mb-3 col-md-6'>
              <label className='form-label'>PAN Number</label>
              <input disabled type='text' className='form-control' value={pan_number} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KycDetails;
